import React, {useContext, useEffect, useState} from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import Button from '@material-ui/core/Button';
import {useCommonStyles} from '../../Styles';
import {
	ck_u_password,
	ck_u_username,
	defDateFormat,
	empty,
	req_cust,
	// req_cust_area,
	// req_cust_category,
	// req_cust_chain,
	req_delete_file,
	req_salesman,
	req_stock,
	req_stock_brand,
	req_stock_category,
	req_stockcount,
	req_stockcount_excel
} from '../../Helper/Constants';
import _ from 'lodash';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import useCookieHook from '../../Services/useCookieHook';
import MUIDataTable from 'mui-datatables';
import {IconButton, Tooltip} from '@material-ui/core';
import {Assessment as AssessmentIcon} from '@material-ui/icons';
import {de} from '../../Helper/Helper';
import useColumnPreference from '../../Services/useColumnPreference';
import LinearLoading from '../../Components/LinearLoading';

const useStyles = makeStyles((theme) => ({
	viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	}
}));

export default function RStockCount() {
	const commonStyle = useCommonStyles();
	const classes = useStyles();
	const singleton = PersistantData.getInstance();
	const [gState] = useContext(AppContext);
	var {translation: language, client} = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang();
	}
	const [cookies] = useCookieHook([ck_u_username, ck_u_password]);
	const {enqueueSnackbar} = useSnackbar();

	const tableHead = [
		{name: "check_in_date", label: language.check_in_date, options: {display: true, customBodyRender: (value) => value ? moment(value).format('YYYY-MM-DD') : '-'}},
		{name: "cust_code", label: language.outlet_code, options: {display: true}},
		{name: "cust_company_name", label: language.customer, options: {display: true}},
		// {name: "cust_category_name", label: language.outlet_category, options: {display: false}},
		// {name: "cust_chain_name", label: language.outlet_chain, options: {display: true}},
		{name: "promoter_name", label: language.promoter_name, options: {display: true}},
		{name: "promoter_code", label: language.promoter_code, options: {display: false}},
		// {name: "cust_area_name", label: language.outlet_area, options: {display: false}},
		{name: "product_code", label: language.item_code, options: {display: true}},
		{name: "product_name", label: language.item_name, options: {display: true}},
		{name: "barcode", label: language.product_barcode, options: {display: false}},
		{name: "prod_category_name", label: language.product_category, options: {display: false}},
		{name: "prod_brand_name", label: language.product_brand, options: {display: false}},
		{name: "opening_qty", label: language.opening_stock, options: {display: true}},
		{name: "closing_qty", label: language.closing_stock, options: {display: true}},
		{name: "sellout_qty", label: language.sell_out, options: {display: true}},
		{name: "sellout_percentage", label: language.sell_out_percentage, options: {display: true}}
	];

	const [splist, setSPlist] = useState([]);
	const [outletList, setOutletList] = useState([]);
	const [itemList, setItemList] = useState([]);
	// const [areaList, setAreaList] = useState([]);
	// const [customerCategoryList, setCustomerCategoryList] = useState([]);
	// const [customerChainList, setCustomerChainList] = useState([]);
	const [productCategoryList, setProductCategoryList] = useState([]);
	const [productBrandList, setProductBrandList] = useState([]);

	const [scList, setSCList] = useState([]);
	const [tableHeader, setTableHeader] = useState([]);
	const {columns: preferredColumns, onColumnViewChange: onPrefColumnViewChange} = useColumnPreference('RStockCount', tableHeader, client);

	const [stockCountDateRange, setStockCountDateRange] = useState({});
	const [openDateDoc, setOpenDateDoc] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const [spView, setSpView] = useState(false);
	const [outletView, setOutletView] = useState(false);
	const [productView, setProductView] = useState(false);
	// const [areaView, setAreaView] = useState(false);
	// const [customerCategoryView, setCustomerCategoryView] = useState(false);
	// const [customerChainView, setCustomerChainView] = useState(false);
	const [productCategoryView, setProductCategoryView] = useState(false);
	const [productBrandView, setProductBrandView] = useState(false);

	const [spSelect, setSpSelect] = useState(empty);
	const [spName, setSpName] = useState(empty);
	const [outletSelect, setOutletSelect] = useState(empty);
	const [outletName, setOutletName] = useState(empty);
	const [productSelect, setProductSelect] = useState(empty);
	const [productName, setProductName] = useState(empty);
	// const [selectedArea, setSelectedArea] = useState(empty);
	// const [selectedAreaName, setSelectedAreaName] = useState(empty);
	// const [selectedCustomerCategoryValue, setSelectedCustomerCategoryValue] = useState(empty);
	// const [selectedCustomerCategory, setSelectedCustomerCategory] = useState(empty);
	// const [selectedCustomerChainValue, setSelectedCustomerChainValue] = useState(empty);
	// const [selectedCustomerChain, setSelectedCustomerChain] = useState(empty);
	const [selectedProductCategoryValue, setSelectedProductCategoryValue] = useState(empty);
	const [selectedProductCategory, setSelectedProductCategory] = useState(empty);
	const [selectedProductBrandValue, setSelectedProductBrandValue] = useState(empty);
	const [selectedProductBrand, setSelectedProductBrand] = useState(empty);

	useEffect(() => {
		if (JString(gState.client).isValid()) {
			getSalesmanList(gState.client);
			getOutletList(gState.client);
			loadStocksList(gState.client);
			// loadCustCategoryList(gState.client);
			// loadCustChainList(gState.client);
			loadProdCategoryList(gState.client);
			loadBrand(gState.client);
			// getAreaList(gState.client);
		}
		setTableHeader(tableHead);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [gState.client, gState.translation]);

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	};

	const joinValues = (newValue) => {
		var value = '';
		for (let i = 0; i < newValue.length; i++) {
			value += (i === newValue.length - 1) ? newValue[i].value : newValue[i].value + ",";
		}
		return value;
	};

	const joinNames = (newValue) => {
		var name = '';
		for (let i = 0; i < newValue.length; i++) {
			name += (i === newValue.length - 1) ? newValue[i].name : newValue[i].name + ",";
		}
		return name;
	};

	const getSalesmanList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			parameters = `?${axiosURIencode({company: gState.company})}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {name, login_id, login, login_status} = extraData[idx];
					_data.push({name: name, secondary: login, value: login_id, status: parseInt(login_status)});
				}
				setSPlist(_data);
			}
		}).catch(err => de(err.message, 'salesman list'));
	};

	const getOutletList = (_client = client) => {
		var parameters = '';
		if (gState.company) {
			parameters = `?${axiosURIencode({company: gState.company})}`;
		}
		API_Service.get(`${req_cust}${parameters}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			var {customer, inactive_customer} = extraData;
			if (parseInt(result) === 1) {
				var arr = [];
				for (let i = 0; i < customer.length; i++) {
					const {cust_code, cust_company_name} = customer[i];
					arr.push({name: cust_company_name, secondary: cust_code, value: cust_code, status: 1});
				}
				for (let i = 0; i < inactive_customer.length; i++) {
					const {cust_code, cust_company_name} = inactive_customer[i];
					arr.push({name: cust_company_name, secondary: cust_code, value: cust_code, status: 0});
				}
				setOutletList(arr);
			}
		}).catch(err => de(err.message, 'outlet list'));
	};

	const loadStocksList = (_client = client) => {
		API_Service.get(`${req_stock}-1`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			const {stock: stockApi} = extraData;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < stockApi.length; idx++) {
					const {product_name, product_code, product_status} = stockApi[idx];
					_data.push({name: product_name, secondary: product_code, value: product_code, status: parseInt(product_status)});
				}
				setItemList(_data);
			}
		}).catch(err => de(err.message, 'stock list'));
	};

	/* const loadCustCategoryList = (_client = client) => {
		API_Service.get(req_cust_category, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData} = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_category_id, cust_category_code, cust_category_name, cust_category_status} = extraData[i];
						_arr.push({name: cust_category_name, secondary: cust_category_code, value: cust_category_id, status: parseInt(cust_category_status) === 1 ? 1 : 0});
					}
					setCustomerCategoryList(_arr);
				}
			}
		}).catch(err => de(err.message, 'customer category list'));
	}; */

	/* const loadCustChainList = (_client = client) => {
		API_Service.get(req_cust_chain, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData} = data;
				if (parseInt(result) === 1) {
					var _arr = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_chain_id, cust_chain_code, cust_chain_name, cust_chain_status} = extraData[i];
						_arr.push({name: cust_chain_name, secondary: cust_chain_code, value: cust_chain_id, status: parseInt(cust_chain_status) === 1 ? 1 : 0});
					}
					setCustomerChainList(_arr);
				}
			}
		}).catch(err => de(err.message, 'customer chain list'));
	}; */

	const loadProdCategoryList = (_client = client) => {
		API_Service.get(req_stock_category, axiosDefaultConfig(_client)).then(({data}) => {
			if (!_.isEmpty(data)) {
				var _arr = [];
				for (let idx = 0; idx < data.length; idx++) {
					const {category_id, categoryIdentifierId, category_name, category_status} = data[idx];
					_arr.push({name: category_name, secondary: categoryIdentifierId, value: category_id, status: parseInt(category_status) === 1 ? 1 : 0});
				}
				setProductCategoryList(_arr);
			}
		}).catch(err => de(err.message, 'product category list'));
	};

	const loadBrand = (_client = client) => {
		API_Service.get(req_stock_brand, axiosDefaultConfig(_client)).then(({data}) => {
			var _arr = [];
			if (!_.isEmpty(data)) {
				for (let idx = 0; idx < data.length; idx++) {
					const {brand_id, brand_code, brand_name, brand_status} = data[idx];
					_arr.push({name: brand_name, secondary: brand_code, value: brand_id, status: parseInt(brand_status) === 1 ? 1 : 0});
				}
			}
			setProductBrandList(_arr);
		}).catch(err => de(err.message, 'product brand list'));
	};

	/* const getAreaList = (_client = client) => {
		API_Service.get(req_cust_area, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (parseInt(result) === 1) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {area_name, area_code, area_status} = extraData[idx];
					_data.push({name: area_name, secondary: area_code, value: area_code, status: parseInt(area_status)});
				}
				setAreaList(_data);
			}
		}).catch(err => de(err.message, 'area list'));
	}; */

	const SpViewClose = (newValue) => {
		setSpView(false);
		if (newValue) {
			setSpSelect(joinValues(newValue));
			setSpName(joinNames(newValue));
		}
	};

	const OutletViewClose = (newValue) => {
		setOutletView(false);
		if (newValue) {
			setOutletSelect(joinValues(newValue));
			setOutletName(joinNames(newValue));
		}
	};

	const ProductViewClose = (newValue) => {
		setProductView(false);
		if (newValue) {
			setProductSelect(joinValues(newValue));
			setProductName(joinNames(newValue));
		}
	};

	/* const AreaViewClose = (newValue) => {
		setAreaView(false);
		if (newValue) {
			setSelectedArea(joinValues(newValue));
			setSelectedAreaName(joinNames(newValue));
		}
	}; */

	/* const OnCloseCustomerCategoryView = (data) => {
		setCustomerCategoryView(false);
		if (data) {
			setSelectedCustomerCategoryValue(joinValues(data));
			setSelectedCustomerCategory(joinNames(data));
		}
	}; */

	/* const OnCloseCustomerChainView = (data) => {
		setCustomerChainView(false);
		if (data) {
			setSelectedCustomerChainValue(joinValues(data));
			setSelectedCustomerChain(joinNames(data));
		}
	}; */

	const OnCloseProductCategoryView = (data) => {
		setProductCategoryView(false);
		if (data) {
			setSelectedProductCategoryValue(joinValues(data));
			setSelectedProductCategory(joinNames(data));
		}
	};

	const OnCloseProductBrandView = (data) => {
		setProductBrandView(false);
		if (data) {
			setSelectedProductBrandValue(joinValues(data));
			setSelectedProductBrand(joinNames(data));
		}
	};

	const getDateLabel = () => {
		return !_.isEmpty(stockCountDateRange)
			? moment(stockCountDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(stockCountDateRange.endDate).format('DD MMMM YYYY')
			: moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
	};

	const buildParameters = () => {
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(stockCountDateRange)) {
			st_date = format(stockCountDateRange.startDate, defDateFormat);
			st_date_to = format(stockCountDateRange.endDate, defDateFormat);
		}
		var parameters = {
			client: client,
			date_from: st_date,
			date_to: st_date_to,
			salespersonId: spSelect,
			cust_code: outletSelect,
			// cust_category_id: selectedCustomerCategoryValue,
			// cust_chain_id: selectedCustomerChainValue,
			product_code: productSelect,
			prod_category_id: selectedProductCategoryValue,
			prod_brand_id: selectedProductBrandValue,
			// area: selectedArea,
			username: cookies(ck_u_username)
		};
		if (gState.company) {
			parameters.company = gState.company;
		}
		return parameters;
	};

	const processStockCount = (rows) => {
		return (rows || []).map((r) => {
			const opening = Math.round(Number(r.opening_qty) || 0);
			const closing = Math.round(Number(r.closing_qty) || 0);
			const sellout = Math.round(Number(r.sellout_qty) || 0);
			const pct = opening > 0 ? Math.round((sellout / opening) * 100) : 0;
			return {
				...r,
				opening_qty: opening,
				closing_qty: closing,
				sellout_qty: sellout,
				sellout_percentage: `(${pct}%)`
			};
		});
	};

	const getStockCount = (_client = client) => {
		setIsLoading(true);
		const param = axiosURIencode(buildParameters());
		API_Service.get(`${req_stockcount}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (parseInt(result) === 1) {
				setSCList(processStockCount(extraData));
			} else {
				setSCList([]);
				snack(language.no_data, 'warning');
			}
			setIsLoading(false);
		}).catch(() => {
			setSCList([]);
			snack(language.network_error || 'Network error', 'error');
			setIsLoading(false);
		});
	};

	const getVisibleColumnKeys = () => {
		const cols = (preferredColumns && preferredColumns.length > 0) ? preferredColumns : tableHeader;
		return cols
			.filter((c) => {
				const disp = c.options ? c.options.display : true;
				return disp !== false && disp !== 'false' && disp !== 'excluded';
			})
			.map((c) => c.name);
	};

	const generateReport = (_client = client) => {
		setIsLoading(true);
		var parameters = buildParameters();
		parameters.columns = getVisibleColumnKeys().join(',');
		const param = axiosURIencode(parameters);
		API_Service.get(`${req_stockcount_excel}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (parseInt(result) === 1 && extraData && extraData.url) {
				window.open(extraData.url, '_blank');
				const delay = setTimeout(() => {
					API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
					clearTimeout(delay);
				}, 5000);
			} else {
				snack(data.message || language.no_data, 'warning');
			}
			setIsLoading(false);
		}).catch(() => {
			snack(language.network_error || 'Network error', 'error');
			setIsLoading(false);
		});
	};

	const filterButton = (label, onClick) => (
		<Button
			style={{width: 300, marginRight: 10}}
			variant="outlined"
			onClick={onClick}
			endIcon={<KeyboardArrowDownRoundedIcon/>}>
			<Typography className={commonStyle.searchBtnFont}>
				{label}
			</Typography>
		</Button>
	);

	return (
		<div>
			<div className={classes.viewInRow}>
				{filterButton(spName ? _.truncate(spName, {length: 20}) : language.salesperson, () => setSpView(true))}
				{filterButton(outletName ? _.truncate(outletName, {length: 20}) : language.customer, () => setOutletView(true))}
				{/* {filterButton(selectedCustomerCategory ? _.truncate(selectedCustomerCategory, {length: 20}) : language.outlet_category, () => setCustomerCategoryView(true))} */}
				{/* {filterButton(selectedCustomerChain ? _.truncate(selectedCustomerChain, {length: 20}) : language.outlet_chain, () => setCustomerChainView(true))} */}
				{/* {filterButton(selectedAreaName ? _.truncate(selectedAreaName, {length: 20}) : language.area, () => setAreaView(true))} */}
				{filterButton(productName ? _.truncate(productName, {length: 20}) : language.items, () => setProductView(true))}
				{filterButton(selectedProductCategory ? _.truncate(selectedProductCategory, {length: 20}) : language.product_category, () => setProductCategoryView(true))}
				{filterButton(selectedProductBrand ? _.truncate(selectedProductBrand, {length: 20}) : language.product_brand, () => setProductBrandView(true))}
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOpenDateDoc(true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{getDateLabel()}
					</Typography>
				</Button>
				<Button
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => getStockCount()}>
					<Typography className={commonStyle.searchBtnFont}>
						{language.view}
					</Typography>
				</Button>
			</div>
			<div style={{height: 20}}/>
			{isLoading && <LinearLoading/>}
			{
				!isLoading && scList.length > 0 && (
					<MUIDataTable
						title={language.stock_count}
						data={scList}
						columns={preferredColumns}
						options={{
							search: false,
							print: false,
							filter: false,
							download: false,
							selectableRows: 'none',
							rowsPerPage: 20,
							rowsPerPageOptions: [20, 50, 100],
							responsive: 'standard',
							onColumnViewChange: onPrefColumnViewChange,
							customToolbar: () => <CheckinTableReportButton onGenerateReport={generateReport}/>,
							setTableProps: () => ({style: {whiteSpace: 'nowrap'}})
						}}
					/>
				)
			}

			<VirtualListCB
				open={spView}
				setClose={data => SpViewClose(data)}
				title={language.salesperson}
				data={splist}
				language={language}
				filteration={1}
			/>
			<VirtualListCB
				open={outletView}
				setClose={data => OutletViewClose(data)}
				title={language.customer}
				data={outletList}
				language={language}
				filteration={1}
			/>
			{/* <VirtualListCB
				open={customerCategoryView}
				setClose={data => OnCloseCustomerCategoryView(data)}
				title={language.outlet_category}
				data={customerCategoryList}
				language={language}
				filteration={1}
			/> */}
			{/* <VirtualListCB
				open={customerChainView}
				setClose={data => OnCloseCustomerChainView(data)}
				title={language.outlet_chain}
				data={customerChainList}
				language={language}
				filteration={1}
			/> */}
			{/* <VirtualListCB
				open={areaView}
				setClose={data => AreaViewClose(data)}
				title={language.area}
				data={areaList}
				language={language}
				filteration={1}
			/> */}
			<VirtualListCB
				open={productView}
				setClose={data => ProductViewClose(data)}
				title={language.items}
				data={itemList}
				language={language}
				filteration={1}
			/>
			<VirtualListCB
				open={productCategoryView}
				setClose={data => OnCloseProductCategoryView(data)}
				title={language.product_category}
				data={productCategoryList}
				language={language}
				filteration={1}
			/>
			<VirtualListCB
				open={productBrandView}
				setClose={data => OnCloseProductBrandView(data)}
				title={language.product_brand}
				data={productBrandList}
				language={language}
				filteration={1}
			/>

			<DateRangePickerModal
				setPositive={range => {
					setStockCountDateRange(range);
					setOpenDateDoc(false);
				}}
				setNegative={() => {
					setOpenDateDoc(false);
				}}
				setClose={() => {
					setOpenDateDoc(false);
				}}
				open={openDateDoc}
				message={language.date_range}
				positive={language.ok}
				negative={language.cancel}
			/>
		</div>
	);
}

function CheckinTableReportButton({onGenerateReport}) {
	return (
		<React.Fragment>
			<Tooltip title={'Generate Report'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => onGenerateReport()} aria-label="generate-report">
					<AssessmentIcon/>
				</IconButton>
			</Tooltip>
		</React.Fragment>
	);
}
